import React from 'react'
import { connect } from 'react-redux'
import {
	addFlashMessage,
	hideLoader,
	showLoader,
	setAppointmentsBookingResult
} from '../../../../actions'
import { BOOKING_TYPES } from '../constants'
import ConfirmMultipleAppointment from './ConfirmMultipleAppointment'
import ConfirmSingleAppointment from './ConfirmSingleAppointment'

const ConfirmAppointment = props => {
	if (props.bookingType === BOOKING_TYPES.MULTIPLE) {
		return <ConfirmMultipleAppointment {...props} />
	}

	return <ConfirmSingleAppointment {...props} />
}

function mapStateToProps({ patient, auth, appointment }) {
	return {
		patient,
		auth,
		turn: appointment.booking.selectedTurn,
		cartTurns: appointment.booking.cartTurns,
		clinics: appointment.booking.catalogs.clinics,
		bookingType: appointment.booking.mode
	}
}

const mapDispatchToProps = {
	showLoader,
	hideLoader,
	addFlashMessage,
	setAppointmentsBookingResult
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAppointment)
